import React, { useState, useEffect } from 'react';
import { Button } from '@material-ui/core/';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import style from './Common.module.css';
import {
  countriesArrayAction,
  regionsArrayAction,
  resortsArrayAction,
} from '../../../../redux/actions/resort';
import { setCardDetailsAction } from '../../../../redux/actions/map';
import { connect } from 'react-redux';
import {
  getMapAction,
  erasePastMapHandler,
} from '../../../../redux/actions/map';
import { withRouter } from 'react-router-dom';
import { removeCoordsDataAction } from '../../../../redux/actions/coordinates';

const ResortContent = ({
  countriesArrayAction,
  resortsArrayAction,
  countries,
  regions,
  resorts,
  getMapAction,
  history,
  regionsArrayAction,
  onClose,
  removeCoordsDataAction,
  erasePastMapHandler,
  setCardDetailsAction,
}) => {
  const [country, setCountry] = useState({ name: '', id: '' });
  const [region, setRegion] = useState({ name: '', id: '' });
  const [resort, setResort] = useState({ name: '', id: '' });

  useEffect(() => {
    const listener = (event) => {
      if (
        (event.code === 'Enter' || event.code === 'NumpadEnter') &&
        resort &&
        resort.id &&
        resort.id !== ''
      ) {
        applyHandler();
      }
    };
    document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [resort]);

  useEffect(() => {
    countriesArrayAction();
  }, []);

  const onCountryChange = (event, values, reason) => {
    if (reason === 'select-option') {
      setCountry(values);
      regionsArrayAction(values.id);
      resortsArrayAction(values.id);
      setRegion({ name: '', id: '' });
      setResort({ name: '', id: '' });
    }

    if (reason === 'clear') {
      setRegion({ name: '', id: '' });
      setCountry({ name: '', id: '' });
      setResort({ name: '', id: '' });
    }
  };

  const onRegionChange = (event, values, reason) => {
    if (reason === 'select-option') {
      setRegion(values);
      resortsArrayAction(values.id);
      setResort({ name: '', id: '' });
    }

    if (reason === 'clear') {
      setResort({ name: '', id: '' });
      setRegion({ name: '', id: '' });
    }
  };

  const onResortChange = (event, values, reason) => {
    if (reason === 'select-option') {
      setResort(values);
    }

    if (reason === 'clear') {
      setResort({ name: '', id: '' });
    }
  };

  const applyHandler = () => {
    if (resort && resort.id) {
      erasePastMapHandler();
      removeCoordsDataAction();
      onClose();
      const { id, name } = resort
      history.push(
        `/${name.replace(/ /g, '-')}/${id}`
      );
    }
    setCardDetailsAction({
      country: country.name,
      region: region.name,
      resort: resort.name,
    });
  };
  const sortedOptions = [...[resort], ...resorts].sort((a, b) => {
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    return 0;
  });

  return (
    <>
      <div className={style.wrapper}>
        <div className={style.Dropdown}>
          <Autocomplete
            id="country"
            disabled={countries.length > 0 ? false : true}
            options={countries}
            getOptionLabel={(option) => option.name}
            style={{ width: 300 }}
            onChange={onCountryChange}
            blurOnSelect={false}
            options={[...[country], ...countries]}
            filterSelectedOptions
            value={country}
            disabled={!countries || countries.length <= 0}
            renderInput={(params) => (
              <TextField {...params} label="Country" variant="outlined" />
            )}
          />
        </div>
        <div className={style.Dropdown}>
          <Autocomplete
            id="region"
            value={region}
            disabled={regions.length <= 0 || !country.name}
            getOptionLabel={(option) => option.name}
            style={{ width: 300 }}
            onChange={onRegionChange}
            blurOnSelect={false}
            options={[...[region], ...regions]}
            filterSelectedOptions
            renderInput={(params) => (
              <TextField {...params} label="Region" variant="outlined" />
            )}
          />
        </div>
        <div className={style.Dropdown}>
          <Autocomplete
            id="resort"
            blurOnSelect={false}
            options={sortedOptions}
            filterSelectedOptions
            value={resort}
            disabled={resorts.length <= 0 || (regions.length && !region.name) || !country.name}
            getOptionLabel={(option) => option.name}
            style={{ width: 300 }}
            onChange={onResortChange}
            renderInput={(params) => (
              <TextField {...params} label="Resort" variant="outlined" />
            )}
          />
        </div>
        <div className={style.btnGroup}>
          <Button
            disabled={!resort || resort.id === ''}
            onClick={applyHandler}
            style={{ margin: '0 auto' }}
          >
            apply
          </Button>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    countries: state.resorts.countries,
    regions: state.resorts.regions,
    resorts: state.resorts.resorts,
  };
};

const mapDispatchToProps = {
  countriesArrayAction,
  regionsArrayAction,
  resortsArrayAction,
  getMapAction,
  removeCoordsDataAction,
  erasePastMapHandler,
  setCardDetailsAction,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ResortContent)
);
